import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'ja', 'zh', 'mi', 'es'],
    ns: [
      'common',
      'embed',
      'packageSetup',
      'upload',
      'observation',
      'moderationHub',
      'rubric'
    ],
    defaultNS: 'common',
    react: {
      useSuspense: false // disables suspense — no Suspense wrapper needed
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: { escapeValue: false }
  });

// Helper to dynamically load translation JSONs
export async function loadLanguage(language: string) {
  const namespaces = [
    'common',
    'embed',
    'packageSetup',
    'upload',
    'observation',
    'moderationHub',
    'rubric'
  ];
  await Promise.all(
    namespaces.map(async (ns) => {
      if (i18n.hasResourceBundle(language, ns)) return;
      const module = await import(
        `../../public/locales/${language}/${ns}.json`
      );
      i18n.addResourceBundle(language, ns, module.default, true, true);
    })
  );
}

export default i18n;
